import { FileViewer as AntdFileViewer } from "@empglabs/backoffice-ui-kit"

const FileViewer = props => {
  return <AntdFileViewer {...props} />
}

export default FileViewer
